module.exports = __webpack_public_path__ + "static/img/v9.7a254a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v9.jpg
// module id = aGVi
// module chunks = 1